var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('request-profile', {
    attrs: {
      "is-individual": _vm.isIndividual,
      "is-identification-required": _vm.isIdentificationRequired,
      "on-validate": _vm.validateForm,
      "fields": _vm.fieldsWithScansObj,
      "on-create": _vm.createRequest,
      "onUpload": _vm.uploadScan,
      "regions": _vm.regions,
      "total": _vm.total,
      "productId": _vm.firstProductId,
      "productData": _vm.productData
    },
    on: {
      "download-contract": _vm.downloadProfileContract
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4bb25ce","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestProfile/RequestProfileContainer.vue
// module id = 1089
// module chunks = 0